var map = {
	"./cubefield/Main": [
		5227,
		445,
		76,
		7
	],
	"./hint/Main": [
		3623,
		445,
		351,
		76,
		420,
		4
	],
	"./listmaster/Main": [
		1879,
		445,
		351,
		76,
		420,
		879
	],
	"./mapselect/Main": [
		5284,
		445,
		942,
		351,
		76,
		420,
		284
	],
	"./pindrop/Main": [
		5239,
		445,
		942,
		547,
		76,
		766
	],
	"./quiz/Main": [
		841,
		445,
		76,
		985
	],
	"./snake/Main": [
		1630,
		445,
		76,
		376
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9468;
module.exports = webpackAsyncContext;